import { render, staticRenderFns } from "./EditAttributesComponent.vue?vue&type=template&id=dce6ce3a&scoped=true"
import script from "./EditAttributesComponent.vue?vue&type=script&lang=js"
export * from "./EditAttributesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce6ce3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dce6ce3a')) {
      api.createRecord('dce6ce3a', component.options)
    } else {
      api.reload('dce6ce3a', component.options)
    }
    module.hot.accept("./EditAttributesComponent.vue?vue&type=template&id=dce6ce3a&scoped=true", function () {
      api.rerender('dce6ce3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/EditAttributesComponent.vue"
export default component.exports